export function getAuthorityUrl(): string {
    const host = location.hostname;
    const appName = host.split(".")[0].replace("test", "");
    const newHost = host.replace(appName, "id");
    const authority = `https://${newHost}`;
    return authority;
}
